module.exports = __webpack_public_path__ + "img/badge-appstore.1cc381c.png";